import { useApp } from "@/context/AppContext";
import { DOCTORS } from "@/lib/site";
import { Seo, PageHeader } from "@/components/common";

export default function Doctors() {
  const { t } = useApp();
  return (
    <main data-testid="doctors-page">
      <Seo title={t({ tr: "Hekimlerimiz", en: "Our Doctors" })} description={t({ tr: "Zeta Clinic hekim kadrosu: uzmanlık, diploma bilgisi ve konuşulan diller.", en: "Zeta Clinic medical team: specialisation, diploma details and spoken languages." })} />
      <PageHeader
        tag={{ tr: "Hekimler", en: "Doctors" }}
        title={{ tr: "Tedavinizi planlayan hekimler", en: "The dentists planning your treatment" }}
        subtitle={{ tr: "Tüm hekimlerimizin diploma ve uzmanlık bilgileri şeffaf şekilde paylaşılır.", en: "Diploma and specialisation details of all our dentists are shared transparently." }}
      />
      <section className="max-w-6xl mx-auto px-6 md:px-12 pb-8">
        <div className="grid md:grid-cols-3 gap-6">
          {DOCTORS.map((d) => (
            <div key={d.id} className="rounded-xl glass-card p-8" data-testid={`doctor-profile-${d.id}`}>
              <div className="w-16 h-16 rounded-full bg-[var(--accent-soft)] text-[var(--accent)] font-heading font-bold flex items-center justify-center text-xl mb-6">
                {d.name.split(" ").slice(-2).map((w) => w[0]).join("")}
              </div>
              <h2 className="font-heading font-semibold text-lg text-[#F2F5F7]">{d.name}</h2>
              <p className="text-sm text-[var(--accent)] font-medium mt-1">{t(d.title)}</p>
              <dl className="mt-5 space-y-3 text-sm">
                <div>
                  <dt className="text-xs uppercase tracking-wide text-[#7C8B97] font-semibold">{t({ tr: "Diploma", en: "Diploma" })}</dt>
                  <dd className="text-[#94A3AE] mt-0.5">{d.diploma}</dd>
                </div>
                <div>
                  <dt className="text-xs uppercase tracking-wide text-[#7C8B97] font-semibold">{t({ tr: "Deneyim", en: "Experience" })}</dt>
                  <dd className="text-[#94A3AE] mt-0.5">{d.years} {t({ tr: "yıl", en: "years" })}</dd>
                </div>
                <div>
                  <dt className="text-xs uppercase tracking-wide text-[#7C8B97] font-semibold">{t({ tr: "İlgi alanları", en: "Areas of focus" })}</dt>
                  <dd className="text-[#94A3AE] mt-0.5">{t(d.focus)}</dd>
                </div>
                <div>
                  <dt className="text-xs uppercase tracking-wide text-[#7C8B97] font-semibold">{t({ tr: "Diller", en: "Languages" })}</dt>
                  <dd className="text-[#94A3AE] mt-0.5">{d.langs.join(" · ")}</dd>
                </div>
              </dl>
            </div>
          ))}
        </div>
        <p className="mt-8 text-xs text-[#7C8B97]">
          {t({ tr: "Hekim fotoğrafları ve güncel diploma bilgileri yayına alınmadan önce eklenecektir.", en: "Doctor photographs and up-to-date diploma details will be added before launch." })}
        </p>
      </section>
    </main>
  );
}
